import { render } from "./VoiceMail.vue?vue&type=template&id=d54537c0&scoped=true"
import script from "./VoiceMail.vue?vue&type=script&lang=js"
export * from "./VoiceMail.vue?vue&type=script&lang=js"

import "./VoiceMail.vue?vue&type=style&index=0&id=d54537c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d54537c0"]])

export default __exports__